import { useEffect, useState } from "react";
import { useCurrency } from "../Context/CurrencyContext";
import axios from "axios";

const CategoryPriceBox = ({ category }) => {
  const [priceData, setPriceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { currency, conversionRate, loading: currencyLoading } = useCurrency();

  const isYearlyCategory =
    category?.toLowerCase() === "microsoft-365" ||
    category?.toLowerCase() === "ssl" ||
    category?.toLowerCase() === "wordpress-hosting";

  const duration = isYearlyCategory ? "yr" : "mo";

  const calculatePrice = (price, duration) => {
    switch (duration) {
      case "yearly":
        return price * 12;
      default:
        return price;
    }
  };

  useEffect(() => {
    if (!category) return;

    const fetchPrice = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${import.meta.env.VITE_BACKEND_API_URL}/admin/get-web-plans?category=${encodeURIComponent(
            category
          )}`
        );

        const plans = res?.data?.plans || [];
        if (!plans.length) throw new Error("No plans found");

        const plan = plans[0];

        setPriceData({
          categoryName: plan?.category?.name || category,
          price: plan.price,
          cutOffPrice: plan.cutOffPrice,
        });
      } catch (err) {
        console.error(err);
        setError("Failed to load price");
      } finally {
        setLoading(false);
      }
    };

    // detectCurrency();
    fetchPrice();
  }, [category]);

  if (loading || currencyLoading) return <p>Loading...</p>;
  if (error) return <p className="text-danger">{error}</p>;
  if (!priceData) return null;

  const symbol = currency === "INR" ? "₹" : "$";

  const basePrice = calculatePrice(priceData.price, duration);
  const baseCutOff = calculatePrice(priceData.cutOffPrice, duration);

  const price = Math.round(basePrice * conversionRate);
  const cutOff = Math.round(baseCutOff * conversionRate);

  return (
    <div className="category-price-box">
      <p>
        Starting at:{" "}
        <strong className="text-primary text-decoration-line-through">
          {symbol}
          {cutOff.toLocaleString()} / {duration}
        </strong>
      </p>

      <div className="mt-3">
        <h3>
          <sup>{symbol}</sup>
          {price.toLocaleString()}
          <span className="fs-6 text-muted"> / {duration}</span>
        </h3>
      </div>
    </div>
  );
};

export default CategoryPriceBox;
